import 'slick-carousel';
import debounce from '../helpers/debounce';

const $window = $(window);
const $homeReviews = $('.js-reviews-bar');

const reviewsBar = {
  initialize() {
    if ($homeReviews.length) {
      this.createListeners();
      this.reevaluate();
    }
  },

  createListeners() {
    const debouncedReevaluate = debounce(this.reevaluate.bind(this), 250);

    $window.on('resize', () => {
      debouncedReevaluate();
    });
  },

  reevaluate() {
    const windowWidth = $window.width();

    const isInitialized = $homeReviews.hasClass('slick-initialized');

    if (windowWidth < 768 && !isInitialized) {
      $homeReviews.slick({
        centerMode: true,
        centerPadding: '30px',
        initialSlide: 1,
        arrows: false,
        mobileFirst: true,
        dots: true,
        responsive: [
          {
            breakpoint: 390,
            settings: {
              centerPadding: '90px',
            },
          }, {
            breakpoint: 520,
            settings: {
              centerPadding: '150px',
            },
          }, {
            breakpoint: 680,
            settings: {
              centerPadding: '190px',
            },
          },
        ],
      });
    } else if (windowWidth >= 768 && isInitialized) {
      $homeReviews.slick('unslick');
    }
  },
};

export default reviewsBar;
